var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "samc-field",
    { attrs: { label: _vm.label, disabled: _vm.disabled } },
    [
      _c("samc-dropdown-input", {
        ref: "dropdown",
        attrs: {
          value: _setup.val,
          "text-field": "name",
          "value-field": "id",
          placeholder: _vm.placeholder,
        },
        on: {
          valueChanged: function ($event) {
            return _setup.onValueChanged($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }